import React from "react";
import "./PWDRequisite.css";

const PWDRequisite = ({
  capsLetterFlag,
  numberFlag,
  pwdLengthFlag,
  specialCharFlag,
}) => {
  console.log();
  return (
    <div className="message">
      <p
        className="text-secondary"
        style={{
          fontSize: "1rem",
          // paddingTop: "2%",
        }}
      >
        In order to keep your account secure, please select a password that
        contains:
      </p>

      <p
        className={capsLetterFlag}
        style={{
          fontSize: "1rem",
          marginBottom: "1%",
        }}
      >
        At least 1 capital letter
      </p>
      <p
        style={{
          fontSize: "1rem",
          marginBottom: "1%",
        }}
        className={numberFlag}
      >
        At least 1 number
      </p>
      <p
        style={{
          fontSize: "1rem",
          marginBottom: "1%",
        }}
        className={specialCharFlag}
      >
        At least 1 special character
      </p>
      <p
        style={{
          fontSize: "1rem",
          marginBottom: "1%",
        }}
        className={pwdLengthFlag}
      >
        At least 8 characters in total
      </p>
    </div>
  );
};

export default PWDRequisite;
